import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";

/**
 * Render markdown del backend con sanitización + estilos consistentes.
 *
 * Wrapper sobre react-markdown que:
 *   - Usa remark-gfm para tablas, listas tipo GitHub, autolinks
 *   - Usa rehype-sanitize para bloquear HTML peligroso (defense en profundidad)
 *   - Aplica estilos uniformes a links, tablas, código
 *
 * Uso: <MarkdownView>{response.markdown}</MarkdownView>
 */
export function MarkdownView({ children }) {
  return (
    <div style={styles.box}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ node, ...props }) => (
            <a
              {...props}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#6c63ff" }}
            />
          ),
          table: ({ node, ...props }) => (
            <table {...props} style={styles.table} />
          ),
          th: ({ node, ...props }) => <th {...props} style={styles.th} />,
          td: ({ node, ...props }) => <td {...props} style={styles.td} />,
          code: ({ inline, ...props }) =>
            inline ? (
              <code {...props} style={styles.codeInline} />
            ) : (
              <pre style={styles.codeBlock}>
                <code {...props} />
              </pre>
            ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}

const styles = {
  box: {
    background: "#faf9ff",
    border: "1px solid #e0dbff",
    borderRadius: "10px",
    padding: "20px",
    marginTop: "16px",
    fontSize: "14px",
    lineHeight: "1.7",
    color: "#2a2845",
    fontFamily: "sans-serif",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    margin: "8px 0",
  },
  th: {
    border: "1px solid #d8d4ff",
    padding: "6px 10px",
    background: "#f0eeff",
    textAlign: "left",
  },
  td: {
    border: "1px solid #e0dbff",
    padding: "6px 10px",
  },
  codeInline: {
    background: "#f0eeff",
    padding: "1px 5px",
    borderRadius: "3px",
    fontFamily: "monospace",
    fontSize: "12px",
    color: "#5a50c8",
  },
  codeBlock: {
    background: "#1a1a2e",
    color: "#c8c3ff",
    padding: "10px",
    borderRadius: "8px",
    overflow: "auto",
  },
};
